<!--
 * @Author: Merlin
 * @Date: 2025-05-20 13:25:52
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-26 19:54:43
 * @Description: 
-->
<template>
    <div
        class="absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2"
        :class="[!showSpinImg && !isFast ? 'ringResult' : '']"
    >
        <q-img
            v-if="(resultShow  ) || (!onceBet || props.isSubmiting)"
            width="905"
            height="905"
            src="~assets/webp/ringText.webp"
            class="w-[200px] h-[200px]"
            :class="[
                isFast ? 'scaleImgFast' : 'scaleImg'
            ]"
        />
        <div
            v-else
            class="flex p-[6px] flex-col bg-[#323e8e] rounded-3xl duration-200 pointer-events-none ease-out"

        >
            <div
                class="bg-[#232d6d] text-[40px] h-[66px] rounded-3xl flex m-auto justify-center items-center font-bold w-[151px]"
                :style="{ color: `#${colors[color]}` }"
            >
                {{ mutipler }}x
            </div>
            <div
                v-if="mutipler !== 0"
                class="inline-flex items-center justify-center gap-2 mt-[6px]"
            >
                <CurrentCoin />
                <div class="font-semibold text-[18.9px]">
                    {{ getFixed(winAmount) }}
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { ringConfig, colors } from '../../data';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { fnGetRingConfig } from '@/pages/casino/ringGame/ts/ringGame';
import { oGameName2Api } from '~/common/js/gameAbout';
const { coefficients } = ringConfig;
const showSpinImg = ref(true);
const props = defineProps({
    color: {
        type: String,
        required: true,
    },
    onceBet: {
        type: Boolean,
        required: true,
    },
    segments: {
        type: Number,
        required: true,
    },
    risk: {
        type: String,
        required: true,
    },
    isSubmiting: {
        type: Boolean,
        required: true,
    },
    resultShow: {
        type: Boolean,
        default: true,
    },
    winAmount: {
        type: Number,
        required: true,
    },
    isFast: {
        type: Boolean,
        required: true,
    },
    delay: {
        type: Number,
        default: 900
    }
});
const currentMultiple=ref()
const mutipler = computed(() => {
    return currentMultiple.value?.[props.color]
});

const toSetRingConfig = async ()=>{
    const {coefficients} = await fnGetRingConfig();
    currentMultiple.value = coefficients[props.risk.toLowerCase()][props.segments];
    console.log('当前倍数1：',currentMultiple.value,props)
    console.log(`${oGameName2Api.ringGame} 游戏配置`, currentMultiple,props.color);
}

import.meta.client && fnGetRingConfig()

watch(
    () => props.isSubmiting,
    (val) => {
        if (val) {
            showSpinImg.value = val;
            setTimeout(() => {
                showSpinImg.value = !val;
            }, props.delay);
        }
    },
);
// 监听游戏难得变化
watch(() => props.risk, (newVal) => {
    if (newVal){
        console.log('ring游戏难度监听：',newVal)
        toSetRingConfig();
    }
}, {
    deep: true,
    immediate: true
})
//监听游戏段变化
watch(() => props.segments, (newVal) => {
    if (newVal){
        console.log('ring游戏段数监听：',newVal)
        toSetRingConfig();
    }
}, {
    deep: true,
    immediate: true
})
</script>

<style lang="scss" scoped>
.scaleImg {
    animation: scaleImg 8s linear infinite;
}
.scaleImgFast {
    animation: scaleImg 4s linear infinite;
}
.ringResult {
    animation: ringResultAmimation 0.15s linear 1;
}

@keyframes scaleImg {
    0% {
        transform: scale(2);
    }

    50% {
        transform: scale(1);
    }

    100% {
        transform: scale(2);
    }
}
@keyframes ringResultAmimation {
    0% {
        opacity: 0;
        transform: translate(-50%, -35%) scale(0.7);
    }
    100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}
</style>
